import { Maybe } from "graphql/jsutils/Maybe";
import { Call } from "@/states/call/call.utility.decl";
import { Slice } from "../store.decl";

export type CustomCall = Omit<
  Call,
  | "lineName"
  | "lineLanguage"
  | "transcriptionLanguage"
  | "callsReason"
  | "voicemailsReason"
>;

export type CallSliceState = {
  call: Maybe<CustomCall>;
  setCall: (call: Maybe<CustomCall>) => void;
};

export const createCallSlice: Slice<CallSliceState> = (set) => ({
  call: null,
  setCall: (call) => {
    set(() => ({
      call,
    }));
  },
});
